import React from 'react';
import { SectionNotFound } from '../components/SectionNotFound/SectionNotFound';

export const NotFound = () => {
  return (
    <>
      <SectionNotFound />
    </>
  )
}